import React from "react";
import PropTypes from "prop-types";
import Button from "@components/button";

const ActionGroup = props => (
  <div className="search-menu__actions">
    {props.onClear ? (
      <Button type="button" btnType="blue" onClick={props.onClear}>
        清除
      </Button>
    ) : null}
    <Button type="button" btnType="primary" className="pull-right" onClick={props.onConfirm}>
      确定
    </Button>
  </div>
);

ActionGroup.defaultProps = {
  onClear: null,
};

ActionGroup.propTypes = {
  onClear: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
};

export default ActionGroup;

require("./index.less");